module.exports = __webpack_public_path__ + "static/media/CAJASDEARRANQUE.042a6d0b.png";